export const resetPasswordHints = hint => ({ ...hint, variant: 'default' })
export const updatePasswordHints = password => hint => ({
      ...hint,
      variant: hint.schema.isValidSync(password) ? 'success' : 'error'
    })